import React from 'react';

const Albania = (props) => (
<img src="https://flagsapi.com/AL/flat/64.png"/>
);

export default Albania;




